export const achievementList = [
  [
    {
      achievementId: 1,
      title: "Login Pertama",
      description: "Selamat datang! Kamu telah login untuk pertama kali.",
      goal: 1,
    },
  ],
  [
    {
      achievementId: 2,
      title: "Belajar 10 Aksara",
      description: "Pelajari 10 aksara Batak!",
      goal: 10,
    },
    {
      achievementId: 3,
      title: "Belajar 20 Aksara",
      description: "Pelajari 20 aksara Batak!",
      goal: 20,
    },
    {
      achievementId: 4,
      title: "Belajar Semua Aksara",
      description: "Pelajari semua aksara Batak!",
      goal: 30,
    },
  ],
  [
    {
      achievementId: 5,
      title: "Terjemahkan 5 Kalimat",
      description: "Kamu telah menerjemahkan 5 kalimat!",
      goal: 5,
    },
    {
      achievementId: 6,
      title: "Terjemahkan 10 Kalimat",
      description: "Kamu telah menerjemahkan 10 kalimat!",
      goal: 10,
    },
    {
      achievementId: 7,
      title: "Terjemahkan 20 Kalimat",
      description: "Kamu telah menerjemahkan 20 kalimat!",
      goal: 20,
    },
  ],
  [
    {
      achievementId: 8,
      title: "Selesaikan 1 Modul",
      description: "Modul pertama telah selesai!",
      goal: 1,
    },
    {
      achievementId: 9,
      title: "Selesaikan 3 Modul",
      description: "Tiga modul telah selesai!",
      goal: 3,
    },
    {
      achievementId: 10,
      title: "Selesaikan Semua Modul",
      description: "Semua modul telah selesai!",
      goal: 5,
    },
  ],
];
